import { render } from "./ClickSearchPopup.vue?vue&type=template&id=16c6c97a&scoped=true"
import script from "./ClickSearchPopup.vue?vue&type=script&lang=js"
export * from "./ClickSearchPopup.vue?vue&type=script&lang=js"

import "./ClickSearchPopup.vue?vue&type=style&index=0&id=16c6c97a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c6c97a"]])

export default __exports__